"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Button = ({ label = '', className, contentClassName, onClick, onKeyDown = () => undefined, children, }) => {
    if (children) {
        return ((0, jsx_runtime_1.jsx)("button", { className: className, onClick: onClick, onKeyDown: onKeyDown, children: children }));
    }
    return ((0, jsx_runtime_1.jsx)("button", { className: className, onClick: onClick, onKeyDown: onKeyDown, children: (0, jsx_runtime_1.jsx)("span", { className: contentClassName, children: label }) }));
};
exports.default = Button;
